import React from "react";
import { convertToRgb } from "utils";

const ColorIndicator = ({ className = "", color = "#9495A0" }) => {
    return (
        <div
            className={`${className} color-indicator mr-2 mt-1`}
            style={{
                backgroundColor: color,
                borderColor: convertToRgb(color, 0.3)
            }}
        />
    );
};

export default ColorIndicator;